<main>
    <div class="container">
        <h3>Mot de passe oublié?</h3>
        <label position="floating">
            <p>Courriel</p>
            <input placeholder="Entrer votre courriel" type="email" [(ngModel)]="courriel">
        </label>
        <button (click)="resetPassword()">Envoyer</button>
    </div>
</main>